/* BSC Academy — header · v2 · 25/08/2026

   v2 (Rami, 25/08): non basta che resti in cima. Scorrendo in GIU si ritira,
   scorrendo in SU ricompare — ovunque nella pagina, anche a meta articolo.
   E il patto: mentre leggi non ti sto addosso, appena cerchi la navigazione
   ti trovo gia li, senza dover risalire fino in testa.

   Sta su `position: sticky` e non `fixed` di proposito: cosi in cima alla
   pagina occupa ancora il suo spazio nel flusso e non c'e nulla da
   compensare sotto. Il nascondersi e una `transform`, che non ridisegna
   il layout — mai `top` negativo.

   Compiti:
     1. pubblicare l'altezza vera in --bsc-header-h (gli altri sticky della
        pagina si fermano SOTTO di lui: carte delle aree, pannello FAQ)
     2. ritirarsi e ricomparire
     3. accendere l'ombra quando qualcosa gli scorre sotto
*/
/* ---- il pannello di navigazione su telefono ------------------------------
   Aggiunto il 26/08: sotto i 720px la navigazione era sparita del tutto.
   Il pannello nasce `hidden` nel markup, quindi senza JavaScript non si apre
   e resta invisibile — le stesse voci sono comunque nel footer. */
(function () {
  'use strict';
  var bottone = document.querySelector('[data-bsc-menu]');
  var pannello = document.querySelector('[data-bsc-pannello]');
  if (!bottone || !pannello) { return; }

  /* ⚠️ Quanto schermo resta sotto la barra. Non e `100svh - altezza
     dell'header`: sopra la barra c'e la fascia degli annunci, e a pagina non
     scrollata il pannello finiva ~44px sotto il bordo basso, col pulsante
     dell'account fuori portata. Si misura il FONDO della barra rispetto allo
     schermo, che tiene conto di tutto quello che le sta sopra.

     Si misura solo all'apertura, e non e la stessa variabile dell'header:
     `--bsc-header-h` la consumano gli sticky di tutta la pagina, e infilarci
     dentro un valore che cambia quando apri il menu e esattamente il ciclo
     di lampeggio del 26/08. → Errori_e_soluzioni.md §0.1.32 */
  var barraMenu = document.querySelector('.bsc-header__in');

  function misuraTetto() {
    if (!barraMenu) { return; }
    var giu = Math.max(0, Math.round(barraMenu.getBoundingClientRect().bottom));
    document.documentElement.style.setProperty('--bsc-menu-top', giu + 'px');
  }

  function apri(si) {
    if (si) { misuraTetto(); }
    pannello.hidden = !si;
    bottone.setAttribute('aria-expanded', si ? 'true' : 'false');
    document.documentElement.classList.toggle('bsc-menu-aperto', si);
  }

  bottone.addEventListener('click', function () {
    apri(pannello.hidden);
  });

  /* si chiude da solo quando si sceglie qualcosa, quando si preme Esc, e
     quando lo schermo diventa largo abbastanza da avere la navigazione in
     riga — o resterebbe aperto sotto un menu che c'e gia */
  pannello.addEventListener('click', function (ev) {
    if (ev.target.closest('a')) { apri(false); }
  });
  document.addEventListener('keydown', function (ev) {
    if (ev.key === 'Escape' && !pannello.hidden) { apri(false); bottone.focus(); }
  });
  addEventListener('resize', function () {
    if (innerWidth > 720 && !pannello.hidden) { apri(false); return; }
    /* girando il telefono cambia tutto: lo schermo, e quanto ne resta sotto */
    if (!pannello.hidden) { misuraTetto(); }
  }, { passive: true });
})();

(function () {
  'use strict';

  var barra = document.querySelector('.bsc-header');
  if (!barra) { return; }

  /* Si muove l'INVOLUCRO di Shopify, non la barra: e lui l'elemento sticky,
     perche e lui il figlio di <body>. → bsc-header.css */
  var header = barra.closest('.bsc-sez-header') || barra;

  var radice = document.documentElement;

  /* soglia: sopra questa quota l'header non si ritira mai. Serve a non farlo
     sfarfallare nei primi pixel, dove il movimento e spesso involontario */
  var FRANCHIGIA = 2;   // moltiplicatore dell'altezza dell'header
  var SOGLIA_MOV = 6;   // px: sotto questo, il movimento non conta

  var altezza = 0;

  /* ⚠️ Si misura la BARRA, non `<header>`. Da quando il pannello del menu
     vive dentro l'header, `barra.offsetHeight` con il pannello aperto valeva
     ~900px invece di 70: la variabile finiva agli sticky di tutta la pagina,
     le carte delle aree si spostavano, la pagina scorreva, l'header si
     ritirava e ricompariva — un ciclo che si vedeva come un lampeggio
     continuo. (Rami, 26/08) → Errori_e_soluzioni.md §0.1.32 */
  var riga = barra.querySelector('.bsc-header__in') || barra;

  function pubblicaAltezza() {
    altezza = riga.offsetHeight;
    radice.style.setProperty('--bsc-header-h', altezza + 'px');
  }

  pubblicaAltezza();

  if (window.ResizeObserver) {
    new ResizeObserver(pubblicaAltezza).observe(riga);
  } else {
    window.addEventListener('resize', pubblicaAltezza);
  }

  /* ---- ritiro e ricomparsa ---------------------------------------------- */
  var ultimo = window.scrollY;
  var ritirato = false;
  var conOmbra = false;
  var inCoda = false;

  function chiudiTendine() {
    /* ⚠️ solo le tendine del menu IN RIGA. Da v3 anche il pannello del
       telefono ha un <details>, e chiuderlo qui vorrebbe dire richiudere la
       fisarmonica sotto il dito di chi la sta scorrendo. (27/08) */
    var aperte = header.querySelectorAll('.bsc-header__nav details[open]');
    for (var i = 0; i < aperte.length; i++) { aperte[i].removeAttribute('open'); }
  }

  function mostra() {
    if (!ritirato) { return; }
    ritirato = false;
    header.classList.remove('is-ritirato');
  }

  function nascondi() {
    if (ritirato) { return; }
    /* con una tendina aperta non si ritira: sparirebbe sotto il dito di
       chi la sta usando */
    if (header.querySelector('.bsc-header__nav details[open]')) { return; }
    /* e nemmeno col pannello del menu aperto, per la stessa ragione */
    if (document.documentElement.classList.contains('bsc-menu-aperto')) { return; }
    /* ne si porta via il focus da tastiera */
    if (header.contains(document.activeElement)) { return; }
    ritirato = true;
    header.classList.add('is-ritirato');
  }

  function leggi() {
    inCoda = false;

    /* iOS rimbalza oltre i due estremi: i valori fuori scala non sono
       movimenti dell'utente e vanno ignorati */
    var max = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
    var y = Math.min(Math.max(window.scrollY, 0), max);
    var delta = y - ultimo;

    var ombra = y > 4;
    if (ombra !== conOmbra) { conOmbra = ombra; header.classList.toggle('is-scrollato', ombra); }

    if (y <= altezza * FRANCHIGIA) { mostra(); ultimo = y; return; }
    if (Math.abs(delta) < SOGLIA_MOV) { return; }   // ultimo NON si aggiorna:
                                                    // i micro-movimenti si sommano
    if (delta > 0) { nascondi(); chiudiTendine(); } else { mostra(); }
    ultimo = y;
  }

  function alloScroll() {
    if (inCoda) { return; }
    inCoda = true;
    requestAnimationFrame(leggi);
  }

  window.addEventListener('scroll', alloScroll, { passive: true });

  /* chi naviga da tastiera non deve inseguire un header che si nasconde */
  header.addEventListener('focusin', mostra);
  /* aprendo una tendina l'header e per forza in scena */
  header.addEventListener('toggle', function (e) {
    if (e.target.open) { mostra(); }
  }, true);

  leggi();

  document.addEventListener('shopify:section:load', pubblicaAltezza);
})();
